import { useState } from "react";
import {NavBar, Footer} from "../component";
const SectionWrapper = (Component, idName) => 
   

    function HOC() {
        const [displayNavBar, setDisplayNavBar] = useState(true);
        return (
            <div>
                <div className="z-2"><NavBar displayNavBar={displayNavBar}/></div>
                <div className="z-1"><Component setDisplayNavBar={setDisplayNavBar} /></div>
                {displayNavBar ? <Footer /> : <></>}
            </div>
        )
    }
    
export default SectionWrapper;